import React from "react";
import { default as MuiCardMedia } from "@mui/material/CardMedia";

function CardMedia(props) {
  return <MuiCardMedia {...props} />;
}

export default CardMedia;
